<template>
  <div>
    <h1>Home Page</h1>

    <v-row>
      <v-col cols="12" xs="12" sm="6" md="7">

        <v-card width="100%">
          <v-card-title>Not Available Yet</v-card-title>
          <v-card-text>
            <p>
              This is the home page for the overall application.  There is nothing to see here yet because we aren't sure what this page will do yet.
              That being said, we left it here in order for app developers to understand that their app will be one of many apps available on the sidebar.
            </p>
            

          </v-card-text>
        </v-card>

     </v-col>
    </v-row>
  </div>
</template>

<script>

  import uiView from "@/_mixins/ui-view-mixin"
  export default {
    name: 'SamplePage',
    mixins : [uiView],
    created()
    {
    },
    props : {},
    watch : {},
    computed : {
    },
    data: () => ({

    }),
    methods : {}

  }
</script>
<style lang="scss">
</style>
